function woocommerceFunctions() {
    if ( $('.variations_form').length ) {
        const variations = $('.variations_form').data('product_variations');
        const variationCount = $('.variations_form .variation').length;
        let variationsChosen = 0;

        $(document).on('click', '.js__variation-elem', function(e) {
            const selectID = $(this).data('variation');
            const value = $(this).data('value');
    
            $('#' + selectID).val(value);
            $('#' + selectID).trigger('change');

            variationsChosen++;

            if ( $(this).hasClass('js__variation-elem--pa_colour') ) {
                const colour = $(this).data('colour');

                $('.js-selected-colour').html(colour);

                console.log(colour);
                const filtered_colour = colour.replace(' ', '-');
                console.log(filtered_colour);

                if ( $(window).width() < 992 && !$(this).hasClass('active') && $('.woocommerce-product-gallery__thumbnail[data-colour="'+filtered_colour+'"]').length ) {
                    const el = $('body');
                    scrollToEl(el, 0, 625);
                }

                $('.js__variation-elem--pa_colour').removeClass('active');
                $(this).addClass('active');
            }

            if ( $(this).hasClass('js__variation-elem--pa_size') ) {
                $('.js__variation-elem--pa_size').removeClass('active');
                $(this).addClass('active');
            }

            if ( variationsChosen >= variationCount ) {
                // If colour and size variation for this product run additional check to see if combination selected is in stock
                if ( variationCount === 2 ) {
                    for (var i = 0; i < variations.length; i++) {
                        const colour = variations[i].attributes.attribute_pa_colour;
                        const size = variations[i].attributes.attribute_pa_size;

                        const colourMatches = colour == $('.js__variation-elem--pa_colour.active').data('value') ? true : false;
                        const sizeMatches = size == $('.js__variation-elem--pa_size.active').data('value') ? true : false;
                        
                        if ( colourMatches && sizeMatches ) {
                            const inStock = variations[i].is_in_stock;
                            const variationID = variations[i].variation_id;

                            if ( inStock ) {
                                $('.single_add_to_cart_button').removeClass('disabled wc-variation-selection-needed');
                                $('input[name="variation_id"]').val(variationID);
                            }
                        }
                    }
                }
                
                const priceHTML = $('.wc-pao-addon').length ? $('.wc-pao-subtotal-line .price .amount').html() : $('.single_variation_wrap .price').html();
                $('.summary p.price').html(priceHTML);

                $('.js-add-product-addon').removeClass('disabled');
            }            
        });
    }

    $(document).on('click', '.js-cross-sell-toggle', function() {
        $('.product-cross-sells').stop().slideToggle();
    });

    // Cross sell products quantity
    $(document).on('click', '.product__quantity-toggle:not(.disabled)', function(e) {
        e.preventDefault();

        const parent = $(this).parent('.product__quantity');
        const location = parent.data('location');
        const currentQuantity = parseInt( parent.find('.product__quantity-current').first().text() );
        const maxQuantity = ( parent.data('max') ? parseInt(parent.data('max')) : 'unlimited' );
        const minQuantity = parent.data('min');  
        const elem = (location == 'product') ? $(this).closest('.product').find('.ajax_add_to_cart') : parent.siblings('.quantity').find('.qty');

        if ( $(this).hasClass('product__quantity-toggle--minus') ) {
            minusQuantity(parent, currentQuantity, minQuantity, maxQuantity, elem, location);
        }

        if ( $(this).hasClass('product__quantity-toggle--plus') ) {
            plusQuantity(parent, currentQuantity, minQuantity, maxQuantity, elem, location);
        }

        if ( location == 'cart' ) {
            // Remove disabled attribute
            $('.button[name="update_cart"]').removeAttr('disabled');
            $('.button[name="update_cart"]').attr('aria-disabled', false);

            $('.button[name="update_cart"]').trigger('click');
            
            // Add disabled attribute
            $('.button[name="update_cart"]').attr('disabled');
            $('.button[name="update_cart"]').attr('aria-disabled', true);
        }
    });  
    
    $(document).on('click', '.js__close-cart-panel', function() {
        $('.cart-panel__container').removeClass('open');
    });
}

function minusQuantity(parent, currentQuantity, minQuantity, maxQuantity, elem, location) {
    const newQuantity = currentQuantity - 1;   

    parent.find('.product__quantity-current').text(newQuantity);

    if ( location == 'product' ) {
        elem.removeAttr('data-quantity');
        elem.attr('data-quantity', newQuantity);
    } else {
        elem.val(newQuantity);
    }

    if ( newQuantity === minQuantity ) {
        parent.find('.product__quantity-toggle--minus').addClass('disabled');
    }

    if ( newQuantity < maxQuantity ) {
        parent.find('.product__quantity-toggle--plus').removeClass('disabled');
    }        
}

function plusQuantity(parent, currentQuantity, minQuantity, maxQuantity, elem, location) {
    const newQuantity = currentQuantity + 1;

    parent.find('.product__quantity-current').text(newQuantity);

    if ( location == 'product' ) {
        elem.removeAttr('data-quantity');
        elem.attr('data-quantity', newQuantity);
    } else {
        elem.val(newQuantity);
    }

    if ( newQuantity > minQuantity ) {
        parent.find('.product__quantity-toggle--minus').removeClass('disabled');
    }

    if ( newQuantity === maxQuantity ) {
        parent.find('.product__quantity-toggle--plus').addClass('disabled');
    }        
}